import { useTranslation } from 'react-i18next';
import { InfoItem } from './components/InfoItem';
import './style.scss';
import { INFO_SECTION_DATA } from './helpers';

export const InfoSection = () => {
  const { t } = useTranslation();

  return (
    <div className="info-section">
      {
        INFO_SECTION_DATA.map(
          ({
            title,
            description,
            icon,
            linkLabel,
            linkUrl,
          }) => {
            return (
              <InfoItem
                key={title}
                icon={icon}
                description={t(description)}
                title={t(title)}
                linkLabel={linkLabel ? t(linkLabel) : undefined}
                linkUrl={linkUrl ? t(linkUrl) : undefined}
              />
            );
          },
        )
      }

    </div>
  );
};
